import LayoutCheckbox from 'components/forms/layoutCheckbox';
import LayoutSelect from 'components/forms/layoutSelect';
import Modal from 'components/layout/modal';
import PropTypes from 'prop-types';
import React from 'react';
import isEqual from 'lodash/isEqual';
import uniqWith from 'lodash/uniqWith';
import {FormattedMessage, intlShape, injectIntl} from 'react-intl';
import {getProducts} from 'helpers/suggestedProductList';
import {saveSuggestedProducts} from 'api/suggestedProduct';
import {countries} from 'helpers/constants';

const MAX_PRODUCTS = 4;

class ProductOption extends React.Component {
  static propTypes = {
    changeBox: PropTypes.func.isRequired,
    id: PropTypes.string.isRequired,
    list: PropTypes.array,
    selected: PropTypes.array,
    title: PropTypes.string.isRequired,
    updateList: PropTypes.func.isRequired,
    values: PropTypes.object.isRequired,
  };

  state = {
    products: [],
  };

  componentWillMount() {
    this.props.selected.forEach(e => this.addProducts(null, e.product));
  };

  componentWillReceiveProps(nextProps) {
    if (!nextProps.list) {
      this.setState({products: []});
    }
  };

  addProducts = (e, selected) => {
    e && e.stopPropagation();
    let {products} = this.state;
    let {id, values} = this.props;

    if (products.length < MAX_PRODUCTS && products.length < values.length) {
      let temp = products;

      temp.push(<LayoutSelect noLabel={true}
                              dataKey={id + 'Layout' + products.length}
                              key={id + 'Layout' + products.length}
                              data-event-category='User'
                              value={selected || 0}
                              editMode={true}
                              dataChanged={this.updateList}
                              options={values.map(k => k.name)}
                              keys={values.map(k => k.id)}
        />
      );

      this.setState({products: temp});
      this.updateList(null, selected || values.map(x => x.id), id);
    }
  };

  removeProduct = () => {
    let {products} = this.state;
    let {updateList, values} = this.props;

    if (products.length) {
      products.pop();

      this.setState({products});
      updateList();
    }
  };

  updateList = (event, value, id) => {
    let {updateList} = this.props;

    if (event) {
      updateList({
        product: event.value,
        productCategory: event.key.slice(0, -7),
      }, event.key.slice(-1));
    } else {
      updateList({
        product: value,
        productCategory: id,
      });
    }
  };

  render() {
    let link;
    let {products} = this.state;
    let {title, id, changeBox, list, values} = this.props;

    return <div key={id + 'BoxContainer'}>
      <LayoutCheckbox label={title}
                      dataKey={id + 'Checkbox'}
                      key={id + 'Checkbox'}
                      data-event-category='User'
                      value={!!list}
                      editMode={true}
                      dataChanged={() => changeBox()}
      />
      {products.map(el => el)}
      {!!list && list.length ? <a className='link'
                                  onClick={this.removeProduct}><FormattedMessage id='preferences.suggested.remove.product'/></a> : null}
      {!!list && list.length < MAX_PRODUCTS ? <a className='link'
                                                 onClick={e => this.addProducts(e, values ? values[0].id : null)}><FormattedMessage id='preferences.suggested.add.product'/></a> : null}
    </div>;
  }
}

class SuggestedProductsModal extends React.Component {
  static propTypes = {
    intl: intlShape.isRequired,
  };

  state = {
    lists: {
      biguanidePoolList: null,
      biguanideSpaList: null,
      halogenPoolList: null,
      halogenSpaList: null,
      mineralSpringsPoolList: null,
      saltPoolList: null,
      saltSpaList: null,
    },
    showError: false,
  };

  close = () => {
    console.log('test');
    this.props.closeModal();
  };

  confirm = () => {
    if (Object.keys(this.state.lists).some(e => !!this.state.lists[e] && this.state.lists[e].length)) {

      let products = this.getProductList();

      this.setState({showError: false});
      saveSuggestedProducts(products)
        .then(() => {
          this.props.savedProducts(products);
          this.close();
        })
        .catch(e => {
          console.error(e);
          this.close();
        });
    } else {
      this.setState({showError: true});
    }
  };

  getProductList = () => {
    let results = [];
    let {lists} = this.state;

    Object.keys(lists).forEach(list => {
      if (lists[list]) {
        results = [...results, ...lists[list]];
      }
    });
    results = results.filter(x => Number.isInteger(parseInt(x.product)));

    return uniqWith(results, isEqual);
  };

  updateList = (k, element, idx) => {
    let temp = this.state.lists;

    if (idx && element) {
      temp[k][idx] = element;
    } else if (element) {
      temp[k] = !!temp[k] ? temp[k] : [];
      temp[k].push(element);
    } else {
      temp[k].pop();
    }

    this.setState({lists: temp});
  };

  updateBox = k => {
    let temp = this.state.lists;

    temp[k] = !!temp[k] ? null : [];
    this.setState({lists: temp});
  };

  getSystemOptions = options => options.map(e => <ProductOption
    changeBox={() => this.updateBox(e.id + 'List')}
    id={e.id}
    key={e.id}
    list={e.list}
    selected={!!this.props.products ? this.props.products.filter(p => p.productCategory === e.id) : []}
    title={this.props.intl.formatMessage({id: e.title})}
    updateList={(element, idx) => this.updateList(e.id + 'List', element, idx)}
    values={e.values}
  />);

  render() {
    const {lists} = this.state;
    const {dealer, ncProductsIntegration} = this.props;
    const {country} = dealer || {country: countries.US};

    let productOptionsPool = [
      {id: 'halogenPool', list: lists.halogenPoolList, title: 'general.halogen', values: getProducts(country, 2, false, ncProductsIntegration)},
      {id: 'biguanidePool', list: lists.biguanidePoolList, title: 'general.biguanide', values: getProducts(country, 3, false, ncProductsIntegration)},
      {id: 'saltPool', list: lists.saltPoolList, title: 'general.salt.pool', values: getProducts(country, 12, false, ncProductsIntegration)},
      {
        id: 'mineralSpringsPool',
        list: lists.mineralSpringsPoolList,
        title: 'general.mineral.springs',
        values: getProducts(country, 7, false, ncProductsIntegration),
      },
    ]
      .filter(x => x && x.values && x.values.length);

    let productOptionsSpa = [
      {id: 'halogenSpa', list: lists.halogenSpaList, title: 'general.halogen', values: getProducts(country, 5, false, ncProductsIntegration)},
      {id: 'biguanideSpa', list: lists.biguanideSpaList, title: 'general.biguanide', values: getProducts(country, 8, false, ncProductsIntegration)},
      {id: 'saltSpa', list: lists.saltSpaList, title: 'general.salt.spa', values: getProducts(country, 13, false, ncProductsIntegration)},
    ]
      .filter(x => x && x.values && x.values.length);

    return <Modal onClose={this.close}>
      {this.state.showError ? <div className='suggested-product-error'>
        <span>
          <i className='icon-bad bl bl-attention'/>
          <FormattedMessage id='preferences.suggested.product.error'/>
        </span>
      </div> : null}
      <div className='suggested-products-modal'>
        <div className='content'>
          <div className='title'><FormattedMessage id='preferences.suggested.products'/></div>
          <div className='description'><FormattedMessage id='preferences.suggested.products.description'/></div>
          <div className='sub-title'><FormattedMessage id='general.pool'/></div>
          <div className='options'>
            {this.getSystemOptions(productOptionsPool)}
          </div>
          <div className='sub-title'><FormattedMessage id='general.spa'/></div>
          <div className='options'>
            {this.getSystemOptions(productOptionsSpa)}
          </div>
        </div>
        <div className='modal-buttons'>
          <a className='gray-button'
             onClick={this.close}><FormattedMessage id='general.cancel'/></a>
          <a className='blue-button'
             onClick={this.confirm.bind(this)}><FormattedMessage id='general.save'/></a>
        </div>
      </div>
    </Modal>;
  }
}

SuggestedProductsModal.propTypes = {
  ncProductsIntegration: PropTypes.bool,
  closeModal: PropTypes.func,
  dealer: PropTypes.object,
  products: PropTypes.array,
  savedProducts: PropTypes.func,
};

export default injectIntl(SuggestedProductsModal);
